import { reportErrorBoundaryError } from 'utils/errorTracking';

import React, { Component, ErrorInfo } from 'react';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, unknown> {
  componentDidCatch(error: Error, info: ErrorInfo): void {
    reportErrorBoundaryError(error, info);
  }

  render(): React.ReactNode {
    const { children } = this.props;

    return children;
  }
}

export default ErrorBoundary;
